// extracted by mini-css-extract-plugin
export var copyableField = "_ro-4";
export var customerBadge = "_ro-0";
export var customerInfoTitle = "_ro-2";
export var details = "_ro-1";
export var dropdownContainer = "_ro-5";
export var dropdownImage = "_ro-6";
export var editAssigneeForm = "_ro-a";
export var editButton = "_ro-3";
export var email = "_ro-7";
export var hidden = "_ro-d";
export var input = "_ro-8";
export var saveButton = "_ro-b";
export var shopifyIcon = "_ro-c";
export var suggestionBadge = "_ro-e";
export var suggestionText = "_ro-f";
export var username = "_ro-9";